/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadAdmissionStatusInfo
 */
export interface PalAuthSubmissionLeadAdmissionStatusInfo {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    action_effective_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    scheduled_action_effective_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    actioned_by?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    booked_by?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    booked_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    target_move_in_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    scheduled_move_out_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    hospitalized_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    hospitalized_by?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    bed_hold?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    bed_hold_end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    move_in_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    move_out_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    bed_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    date_lost?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    lost_by?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    info_last_modified?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    moved_out_by?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    moved_in_by?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    loa_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    loa_by?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    stay_type?: PalAuthSubmissionLeadAdmissionStatusInfoStayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadAdmissionStatusInfo
     */
    readmitted_by_lead_id?: string;
}


/**
 * @export
 */
export const PalAuthSubmissionLeadAdmissionStatusInfoStayTypeEnum = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term'
} as const;
export type PalAuthSubmissionLeadAdmissionStatusInfoStayTypeEnum = typeof PalAuthSubmissionLeadAdmissionStatusInfoStayTypeEnum[keyof typeof PalAuthSubmissionLeadAdmissionStatusInfoStayTypeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionLeadAdmissionStatusInfo interface.
 */
export function instanceOfPalAuthSubmissionLeadAdmissionStatusInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionLeadAdmissionStatusInfoFromJSON(json: any): PalAuthSubmissionLeadAdmissionStatusInfo {
    return PalAuthSubmissionLeadAdmissionStatusInfoFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadAdmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadAdmissionStatusInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action_effective_date': !exists(json, 'action_effective_date') ? undefined : json['action_effective_date'],
        'scheduled_action_effective_date': !exists(json, 'scheduled_action_effective_date') ? undefined : json['scheduled_action_effective_date'],
        'actioned_by': !exists(json, 'actioned_by') ? undefined : json['actioned_by'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'booked_by': !exists(json, 'booked_by') ? undefined : json['booked_by'],
        'booked_at': !exists(json, 'booked_at') ? undefined : json['booked_at'],
        'target_move_in_date': !exists(json, 'target_move_in_date') ? undefined : json['target_move_in_date'],
        'scheduled_move_out_date': !exists(json, 'scheduled_move_out_date') ? undefined : json['scheduled_move_out_date'],
        'hospitalized_date': !exists(json, 'hospitalized_date') ? undefined : json['hospitalized_date'],
        'hospitalized_by': !exists(json, 'hospitalized_by') ? undefined : json['hospitalized_by'],
        'bed_hold': !exists(json, 'bed_hold') ? undefined : json['bed_hold'],
        'bed_hold_end_date': !exists(json, 'bed_hold_end_date') ? undefined : json['bed_hold_end_date'],
        'move_in_date': !exists(json, 'move_in_date') ? undefined : json['move_in_date'],
        'move_out_date': !exists(json, 'move_out_date') ? undefined : json['move_out_date'],
        'bed_id': !exists(json, 'bed_id') ? undefined : json['bed_id'],
        'date_lost': !exists(json, 'date_lost') ? undefined : json['date_lost'],
        'lost_by': !exists(json, 'lost_by') ? undefined : json['lost_by'],
        'info_last_modified': !exists(json, 'info_last_modified') ? undefined : json['info_last_modified'],
        'moved_out_by': !exists(json, 'moved_out_by') ? undefined : json['moved_out_by'],
        'moved_in_by': !exists(json, 'moved_in_by') ? undefined : json['moved_in_by'],
        'loa_date': !exists(json, 'loa_date') ? undefined : json['loa_date'],
        'loa_by': !exists(json, 'loa_by') ? undefined : json['loa_by'],
        'stay_type': !exists(json, 'stay_type') ? undefined : json['stay_type'],
        'readmitted_by_lead_id': !exists(json, 'readmitted_by_lead_id') ? undefined : json['readmitted_by_lead_id'],
    };
}

export function PalAuthSubmissionLeadAdmissionStatusInfoToJSON(value?: PalAuthSubmissionLeadAdmissionStatusInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_effective_date': value.action_effective_date,
        'scheduled_action_effective_date': value.scheduled_action_effective_date,
        'actioned_by': value.actioned_by,
        'reason': value.reason,
        'comment': value.comment,
        'booked_by': value.booked_by,
        'booked_at': value.booked_at,
        'target_move_in_date': value.target_move_in_date,
        'scheduled_move_out_date': value.scheduled_move_out_date,
        'hospitalized_date': value.hospitalized_date,
        'hospitalized_by': value.hospitalized_by,
        'bed_hold': value.bed_hold,
        'bed_hold_end_date': value.bed_hold_end_date,
        'move_in_date': value.move_in_date,
        'move_out_date': value.move_out_date,
        'bed_id': value.bed_id,
        'date_lost': value.date_lost,
        'lost_by': value.lost_by,
        'info_last_modified': value.info_last_modified,
        'moved_out_by': value.moved_out_by,
        'moved_in_by': value.moved_in_by,
        'loa_date': value.loa_date,
        'loa_by': value.loa_by,
        'stay_type': value.stay_type,
        'readmitted_by_lead_id': value.readmitted_by_lead_id,
    };
}

